import { Component, inject, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { NgxAimAdminEditLocationComponent } from './edit-location/ngx-aim-admin-edit-location.component';
import { NgxAimAdminPrimengModule } from '../ngx-aim-admin.primeng.module';
import { AppLazyLoadEvent } from '../../../models';
import { HttpErrorService } from '../../../services';
import { MatchModesPrime } from '../../../enums';
import { NgxAimAdminLocationsService } from './ngx-aim-admin-locations.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'ngx-aim-admin-locations',
  standalone: true,
  imports: [FormsModule, NgxAimAdminPrimengModule, AsyncPipe, NgClass],
  templateUrl: './ngx-aim-admin-locations.component.html',
  styleUrls: ['./ngx-aim-admin-locations.component.scss', '../admin.scss'],
  providers: [DialogService],
})
export class NgxAimAdminLocationsComponent {
  entityService = inject(NgxAimAdminLocationsService);
  dialogService = inject(DialogService);
  httpErrorService = inject(HttpErrorService);
  messageService = inject(MessageService);

  @ViewChild('dt') table: Table | undefined;
  data$ = this.entityService.data$;
  isLoading$ = this.entityService.isLoading$;
  dataCount$ = this.entityService.dataCount$;
  lastLazyLoadEvent: AppLazyLoadEvent = {
    globalFilterFields: [],
    filters: {}
  };
  selectedOptions: string[] = [];
  isSyncing = false;

  onLazyLoad($event: TableLazyLoadEvent) {
    this.lastLazyLoadEvent = $event;
    const lazyLoadEvent: AppLazyLoadEvent = Object.assign({
      withDeleted: this.selectedOptions.includes('withDeleted'),
      globalFilterFields: this.table?.globalFilterFields || [],
    }, $event);

    this.entityService.onFilterEvent(lazyLoadEvent);
  }

  applyFilterGlobal($event: Event) {
    this.table?.filterGlobal(($event.target as HTMLInputElement).value, MatchModesPrime.CONTAINS);
  }

  onSyncClick() {
    this.isSyncing = true;
    this.entityService.sync().subscribe({
      next: () => this.onSyncSuccess(),
      error: (err) => this.onSyncError(err, 'Could not sync locations'),
    });
  }

  onSyncSuccess() {
    this.isSyncing = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Confirmed',
      detail: `Locations synced`,
      key: 'app-toast',
      life: 5000
    });
    this.onLazyLoad(this.lastLazyLoadEvent);
  }

  onSyncError(err: any, summary: string) {
    this.isSyncing = false;
    this.httpErrorService.onHttpError(err, summary);
  }

  openEntity(entityId?: number) {
    const dialog = this.dialogService.open(NgxAimAdminEditLocationComponent, {
      data: entityId,
      header: 'Location',
      width: '800px',
      contentStyle: { "max-height": "580px", "overflow": "auto", "max-width": "100%" },
      dismissableMask: true
    });
    dialog.onClose.subscribe(() => {
      this.onLazyLoad(this.lastLazyLoadEvent);
    });
  }
}
